import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class StoneBridgeTileEntity extends TileEntity {
	public static readonly frameName = FrameName.STONE_BRIDGE;
}

export default StoneBridgeTileEntity;
